import React from "react";
import { RotatingLines } from "react-loader-spinner";

export default function Loader() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{minHeight: "100vh"}}
    >
      <RotatingLines
        strokeColor="grey"
        strokeWidth="5"
        animationDuration="0.75"
        width="56"
        visible={true}
      />
    </div>
  );
}
